import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class NotificationsRepository {
  NOTIFICATIONS_BASE = "/api/notifications";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getOfferNotifications(instance, params) {
    const token = await getToken(instance);
    const path = `${this.NOTIFICATIONS_BASE}/offer?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    return Promise.resolve({
      offerNotifications: req.offerNotifications,
      continuationToken: req.continuationToken
    });
  }
  
  async getNewOfferNotifications(instance, params) {
    const token = await getToken(instance);
    const path = `${this.NOTIFICATIONS_BASE}/newoffers?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    return Promise.resolve({
      offerNotifications: req.offerNotifications,
    });
  }

  async updateOfferNotification(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.NOTIFICATIONS_BASE}/offer/update`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({offerNotification: payload})
    });

    return Promise.resolve(req.offerNotification);
  }

  async updateAllNotificationsAsRead(instance, params) {
    const token = await getToken(instance);
    const path = `${this.NOTIFICATIONS_BASE}/offer/markallread?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "PUT",
      headers: this.headers,
    }, false, true);

    return Promise.resolve();
  }
}